import apiClient from "../../utilities/apiService";

// Fetch user list
export const fetchUserList = async (params) => {
  try {
    const response = await apiClient.get(`${process.env.REACT_APP_BACKEND_URL}/admin/user/list`, {
      params: params,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete user
export const deleteUser = async (id) => {
  try {
    const response = await apiClient.delete(`${process.env.REACT_APP_BACKEND_URL}/admin/user/delete/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch single user data
export const fetchUserData = async (userId) => {
  try {
    const response = await apiClient.get(`${process.env.REACT_APP_BACKEND_URL}/users/${userId}`);
    return response.data?.data?.user; 
  } catch (error) {
    throw error;
  }
};

// Deactivate User
export const deactivateUser = async (userId) => {
  try {
    const response = await apiClient.delete(
      `${process.env.REACT_APP_BACKEND_URL}/admin/user/deactivate/${userId}`
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Make User Admin
export const makeAdmin = async (userId) => {
  try {
    const response = await apiClient.post(
      `${process.env.REACT_APP_BACKEND_URL}/admin/user/updateRole/${userId}`,
      {
        id: userId,
        role: "ROLE_ADMIN",
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Fetch cuisine data
export const fetchCuisineData = async (userId) => {
  try {
    const response = await apiClient.get(`${process.env.REACT_APP_BACKEND_URL}/users/${userId}/cuisines`);
    return response.data?.data?.cuisines || [];
  } catch (error) {
    throw error;
  }
};

// Fetch dietary preferences
export const fetchDietaryPreferences = async (userId) => {
  try {
    const response = await apiClient.get(`${process.env.REACT_APP_BACKEND_URL}/users/${userId}/diets`);
    return response.data?.data?.diets || []; 
  } catch (error) {
    throw error;
  }
};